import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import appServices from "../../../services/app-services/appServices";
import { convertUserImage, getChatUserName } from "../../../util/utils";
import LoadingModal from "../../../components/LoadingModal";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import IconButtonArrow from "../../../components/GreenCity/IconButtonArrow";
import profileImage from "../../../assets/images/profile_img.png";
import groupChatIcon from "../../../assets/images/group_chat.png";
import { Box } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import GroupIconImage from "../../../components/GreenCity/GroupIconImage";
import { ErrorMessageModal } from "../../../components/ErrorMessageModal";

const UserChatList = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [chatList, setChatList] = useState<any[]>([]);
  const [showErrorMessageModal, setShowErrorMessageModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string[]>([]);

  const getMyChatList = async () => {
    try {
      setIsLoading(true)
      const res = await appServices.getAllChatList()
      setChatList(res.chats);
    } catch (error: any) {
      console.error(error)
      setErrorMessage(error?.response?.data?.message ?? T("api_unknown_error"));
      setShowErrorMessageModal(true)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getMyChatList()
  }, []);

  const closeErrorModal = () => {
    navigate(-1);
    setShowErrorMessageModal(false)
  }

  const handleNavigateChat = (chatId: number) => {
    navigate("/userchat", { state: { chatId: chatId }});
  }

  const dispIcon = (chat: any) => {
    if (chat.chat_type === "group") {
      return (
        <GroupIconImage
          groupId={chat.member_group?.id}
          alt=""
          style={{ borderRadius: 13, height: 26, width: 26 }}
          altImg={groupChatIcon}
        />
      )
    } else {
      let userImageList = [];
      if (chat.users.length === 1) {
        const image = user.image ? convertUserImage(user.image) : profileImage
        userImageList = [image]
      } else {
        const displayUsers = chat.users.filter((userData: any) => userData.id !== user.id)
        // 元の実装より最大5人分
        const limit = displayUsers.length > 5 ? 5 : displayUsers.length

        userImageList = [...Array(limit)].map((_: any, i: number) =>
          displayUsers[i]?.image ? convertUserImage(displayUsers[i].image) : profileImage
        )
      }

      return (
        <div style={{ display: "flex" }}>
          {userImageList.map((userImage: any, index: number) => (
            <img
              key={`icon_${index}`}
              alt="User"
              style={{
                width: "26px",
                height: "26px",
                borderRadius: "50%",
                objectFit: "cover",
                marginLeft: index === 0 ? "0px" : "-10px"
              }}
              src={userImage}
            />
          ))}
        </div>
      )
    }
  }

  return (
    <Box>
      <LoadingModal visible={isLoading}/>

      <Box sx={styles.headerBox}>
        <GCBackButton onClick={() => navigate(-1)} />
        <p style={styles.title}>
          <ChatIcon /> {T("chats")}
        </p>
      </Box>

      <Box sx={styles.container} display="flex" flexDirection="column">
        {chatList.map((chat: any) => (
          <IconButtonArrow
            key={chat.id}
            icon={dispIcon(chat)}
            title={chat.chat_type === "group" ? chat.member_group?.name || "No Group Name" : getChatUserName(chat.users, user.id)}
            onClick={() => handleNavigateChat(chat.id)}
          />
        ))}
      </Box>

      <ErrorMessageModal
        open={showErrorMessageModal}
        messages={errorMessage}
        onClose={() => closeErrorModal()}
      />
    </Box>
  );
};

export default UserChatList;

const styles = {
  headerBox: {
    padding: "1px 16px",
    paddingTop: "100px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
  },
  title: {
    marginTop: 10,
    fontSize: 14,
    fontWeight: 600,
    marginLeft: 10
  },
  container: { marginTop: "10px" },
};
